module.exports = __webpack_public_path__ + "static/media/accompany_map.ebc2831d.svg";